import { Activity, Cpu, FileSearch2 } from "lucide-react";
import Booking from "./Booking";
import ServicePageFaqSection from "./ServicePageFaqSection";
import { useFaqPageJsonLd } from "@/hooks/useFaqPageJsonLd";

export default function DiagnosticsPage({ t }) {
  useFaqPageJsonLd(t.diagnosticsPage.faq, "service-diagnostics-faq");

  return (
    <article
      id="diagnostics-page"
      data-testid="diagnostics-page"
      className="bg-white border-b border-[#e2e6ec]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <header>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e3191b] mb-4">
            {t.diagnosticsPage.eyebrow}
          </div>
          <h1 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            {t.diagnosticsPage.title}
          </h1>
          <p className="mt-6 max-w-3xl text-slate-600 leading-relaxed text-base sm:text-lg">
            {t.diagnosticsPage.lead}
          </p>
          {t.diagnosticsPage.secondary ? (
            <p className="mt-5 max-w-3xl text-slate-600 leading-relaxed text-base sm:text-lg">
              {t.diagnosticsPage.secondary}
            </p>
          ) : null}
        </header>

        <div className="mt-8 border border-[#e2e6ec] bg-white overflow-hidden">
          <img
            src="/resources/selena-mecanica.jpg"
            alt={t.diagnosticsPage.heroImageAlt}
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <section className="mt-12" aria-labelledby="diagnostics-cards-heading">
          <h2
            id="diagnostics-cards-heading"
            className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-2xl sm:text-3xl mb-8 max-w-4xl leading-tight"
          >
            {t.diagnosticsPage.cardsSectionTitle}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <Cpu className="w-4 h-4" />
                {t.diagnosticsPage.card1Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.diagnosticsPage.card1Text}</p>
            </div>
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <FileSearch2 className="w-4 h-4" />
                {t.diagnosticsPage.card2Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.diagnosticsPage.card2Text}</p>
            </div>
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <Activity className="w-4 h-4" />
                {t.diagnosticsPage.card3Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.diagnosticsPage.card3Text}</p>
            </div>
          </div>
        </section>

        <ServicePageFaqSection
          headingId="diagnostics-faq-heading"
          title={t.diagnosticsPage.faqTitle}
          faq={t.diagnosticsPage.faq}
        />

        <div className="mt-12">
          <Booking
            t={t}
            initialService={t.services.items.find((item) => item.code === "S/02")?.title || ""}
            copyOverrides={t.diagnosticsPage.bookingCopy}
          />
        </div>
      </div>
    </article>
  );
}
